module.exports = __webpack_public_path__ + "static/facebook-e296392e59b3f0bbe369713f668b92f3.png";